import type { IOrder } from '@/types/Data'
import type { IPaging, IRevokeOrder, IUpdateOrder } from '@/types/Request'
import BaseService from '../BaseService'

export default class OrderServices extends BaseService {
  GetOrderList(payload: IPaging) {
    return this.GET<IOrder[]>(this.PATHS.GET_ORDER_LIST, payload)
  }

  UpdateOrder(payload: IUpdateOrder) {
    return this.POST<IOrder>(this.PATHS.UPDATE_ORDER, payload)
  }

  RevokeOrder(payload: IRevokeOrder) {
    return this.POST<void>(this.PATHS.REVOKE_ORDER, payload)
  }
}
